"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var edit_service_1 = require("./edit.service");
function bhtpEditServiceFactory(http) {
    return new edit_service_1.BhtpEditService(http);
}
exports.bhtpEditServiceFactory = bhtpEditServiceFactory;
/**
 * The module that includes http's providers
 *
 * @experimental
 */
var BhtpEditServiceModule = (function () {
    function BhtpEditServiceModule() {
    }
    return BhtpEditServiceModule;
}());
BhtpEditServiceModule = __decorate([
    core_1.NgModule({
        providers: [
            // TODO(pascal): use factory type annotations once supported in DI
            // issue: https://github.com/angular/angular/issues/3183
            { provide: edit_service_1.BhtpEditService, useFactory: bhtpEditServiceFactory, deps: [http_1.Http] },
        ],
    })
], BhtpEditServiceModule);
exports.BhtpEditServiceModule = BhtpEditServiceModule;
//# sourceMappingURL=D:/a/1/s/edit/src/edit.module.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/edit.module.js